<div class="pl">
  <div class="pl-tools">
    @if (heading()) {
      <span class="pl-heading">{{ heading() }}</span>
    }
    <span class="pl-count">
      {{ 'process.logsUi.lines' | translate: { count: lines().length } }}
      @if (errorCount()) {
        <span class="pl-errors">{{ 'process.logsUi.errors' | translate: { count: errorCount() } }}</span>
      }
    </span>
    @if (lines().length > 15) {
      <input
        class="p-inputtext pl-filter"
        type="search"
        [placeholder]="'process.logsUi.filter' | translate"
        [attr.aria-label]="'process.logsUi.filter' | translate"
        [value]="filter()"
        (input)="filter.set($any($event.target).value)" />
    }
    <span class="pl-spacer"></span>
    <button
      type="button"
      class="pl-tool"
      [disabled]="!lines().length"
      [title]="(copied() ? 'process.logsUi.copied' : 'process.logsUi.copy') | translate"
      [attr.aria-label]="'process.logsUi.copy' | translate"
      (click)="copyAll()">
      <i class="fa-solid" [class.fa-copy]="!copied()" [class.fa-check]="copied()" aria-hidden="true"></i>
    </button>
    <button
      type="button"
      class="pl-tool"
      [disabled]="!lines().length"
      [title]="'process.logsUi.download' | translate"
      [attr.aria-label]="'process.logsUi.download' | translate"
      (click)="download()">
      <i class="fa-solid fa-download" aria-hidden="true"></i>
    </button>
    @if (closable()) {
      <button
        type="button"
        class="pl-tool"
        [title]="'process.logsUi.hide' | translate"
        [attr.aria-label]="'process.logsUi.hide' | translate"
        (click)="closed.emit()">
        <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
      </button>
    }
  </div>
  <div #logsContainer class="process-logs-container pl-list" role="log" aria-live="polite">
    @for (line of shown(); track line.id) {
      <div
        class="process-logs-item pl-item"
        [class.pl-item--error]="line.level === 'error'"
        [class.pl-item--end]="line.level === 'end'"
        [class.pl-item--start]="line.level === 'start'">
        <time class="pl-time">{{ line.time }}</time>
        @if (line.level === 'error') {
          <i class="fa-solid fa-circle-exclamation pl-mark" aria-hidden="true"></i>
        } @else if (line.level === 'end') {
          <i class="fa-solid fa-flag-checkered pl-mark" aria-hidden="true"></i>
        } @else if (line.level === 'start') {
          <i class="fa-solid fa-play pl-mark" aria-hidden="true"></i>
        }
        <span class="pl-text" [innerHTML]="line.html"></span>
      </div>
    } @empty {
      <div class="pl-empty">
        <i class="fa-regular fa-file-lines" aria-hidden="true"></i>
        <span>{{ (lines().length ? 'process.logsUi.noMatch' : 'process.logsUi.empty') | translate }}</span>
      </div>
    }
  </div>
  @if (newBelow()) {
    <button type="button" class="pl-jump" (click)="goToBottom()">
      <i class="fa-solid fa-arrow-down" aria-hidden="true"></i>
      {{ 'process.logsUi.newLines' | translate: { count: newBelow() } }}
    </button>
  }
</div>
